module.exports = __webpack_public_path__ + "static/favicon-bb623af43feac252f5e16769b1534071.ico";